import { useAppConstantsContext } from '@/context/AppConstants';
import {
  Icons,
  Modal,
  Text,
  Button,
  Grid,
  Link,
  Stack,
  CustomIcons,
  Divider,
} from '@/theme/index';

export function EmailVerificationErrorModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const {
    images: { imgExpiredEmailLink },
    data: { brandName },
  } = useAppConstantsContext();

  return (
    <Modal open={open} onClose={onClose}>
      <Button
        sx={{ position: 'absolute', right: '0.5rem', top: '0.5rem' }}
        onClick={onClose}
        color="success"
      >
        <Icons.Close
          sx={(theme) => ({ color: theme.palette.primary.light })}
          fontSize="large"
        />
      </Button>
      <Grid
        container
        sx={{ height: '22rem', width: '32rem' }}
        justifyContent="space-around"
        alignItems="center"
        direction="column"
      >
        <Grid item alignSelf="center" fontSize="7rem">
          <Stack alignItems="center">
            <img
              src={imgExpiredEmailLink}
              alt="Expired email link"
              style={{ height: '80px', width: '60px' }}
            />
          </Stack>
        </Grid>
        <Grid item>
          <Text variant="h3">Unfortunately, the link is expired</Text>
        </Grid>
        <Grid item>
          <Text variant="body1">
            Please click this new link we just sent to your inbox to verify your
            email
          </Text>
        </Grid>
        <Grid item>
          <Link href="https://gmail.com" target="_blank">
            <Button
              variant="outlined"
              sx={{
                maxWidth: 174,
                paddingY: 1,
                whiteSpace: 'nowrap',
              }}
              color="success"
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <CustomIcons.GmailIcon />
                <Stack direction="row" spacing={0.8125} alignItems="center">
                  <Text variant="h5" sx={{ margin: 0, textDecoration: 'none' }}>
                    Open Gmail
                  </Text>
                  <Icons.OpenInNewRounded color="primary" />
                </Stack>
              </Stack>
            </Button>
          </Link>
        </Grid>
        <Grid item textAlign="center">
          <Text variant="caption" color="gray">
            Make sure to check your spam folder if you don't see a verification
            email from BeenVerified in your inbox.{' '}
            <b>This link will expire in 24 hrs.</b>
          </Text>
        </Grid>

        <Divider
          color="secondary"
          sx={{
            width: '100%',
            borderWidth: '1px',
          }}
        />

        <Grid item>
          <Button color="success" variant="contained" onClick={onClose}>
            Continue to {brandName}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
